import { Injectable } from "@angular/core";
import { ApiClientService } from "./api-client.service";

@Injectable()
export class CacheService {
  private readonly prefix = 'agro_cache_';
  private readonly defaultTTL = 12 * 60 * 60 * 1000; // 12 hours in ms

  constructor(private apiClient: ApiClientService) { }

  public async getCachedOrFetch(key: string, fetchFn: () => Promise<any>) {
    const cached = this.get<any>(key);
    if (cached) return cached;
    const data = await fetchFn();
    this.set(key, data);
    return data;
  };

  /** Save an item to cache */
  set<T>(key: string, data: T, ttlMs: number = this.defaultTTL): void {
    const record = {
      value: data,
      expiry: Date.now() + ttlMs
    };
    localStorage.setItem(this.prefix + key, JSON.stringify(record));
  }

  /** Load an item from cache (returns null if expired or not found) */
  get<T>(key: string): T | null {
    const raw = localStorage.getItem(this.prefix + key);
    if (!raw) return null;

    try {
      const record = JSON.parse(raw);
      if (Date.now() > record.expiry) {
        localStorage.removeItem(this.prefix + key);
        return null;
      }
      return record.value as T;
    } catch {
      localStorage.removeItem(this.prefix + key);
      return null;
    }
  }

  /** Remove one item */
  remove(key: string): void {
    localStorage.removeItem(this.prefix + key);
  }

  /** Clear all cache entries from this service */
  clear(): void {
    Object.keys(localStorage)
      .filter(k => k.startsWith(this.prefix))
      .forEach(k => localStorage.removeItem(k));
  }
}